import { motion } from "framer-motion";
import "../css/herosection.css";
import edwin from "../img/ingenieria/edwin2.png";
import eva from "../img/ingenieria/eva2.png";

const fadeUp = {
  hidden: { y: -80, opacity: 0 },
  visible: (delay = 0) => ({
    y: 0,
    opacity: 1,
    transition: {
      delay,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

const slideLeft = {
  hidden: { x: -120, opacity: 0 },
  visible: (delay = 0) => ({
    x: 0,
    opacity: 1,
    transition: {
      delay,
      duration: 0.7,
      ease: "easeOut",
    },
  }),
};

function HeroSection() {
  return (
    <div className="bg1 padding">
      <section className="layout8 hero-section ">
        <div className="flex-center col2">
          {/* Ponentes */}
          <div className="ponentes">
            <div className="flex-start ">
              <img src={eva} alt="Ponente destacado" className="ponente-img" />  <img src={edwin} alt="Ponente destacado" className="ponente-img" />
            </div>{" "}
          
            <div className="margin">
              <a href="#ponentes" className="link-with-arrow">
                Conoce nuestros ponentes destacados
              </a>
            </div>
          </div>

          {/* Contenido principal */}
          <div className="hero-content">
            <motion.p
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              custom={0.2}
              viewport={{ once: true }}
            >
              🗓️ 9, 10 y 11 de noviembre de 2026
            </motion.p>

            <motion.p
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              custom={0.4}
              viewport={{ once: true }}
            >
              📍 Loja, Campus UTPL, Centro de convenciones
            </motion.p>

            <motion.h1
              variants={slideLeft}
              initial="hidden"
              whileInView="visible"
              custom={0.6}
              viewport={{ once: true }}
            >
              Ingeniería Estructural:
              <span> Cimientos de un futuro sostenible</span>
            </motion.h1>

            <motion.p
              variants={slideLeft}
              initial="hidden"
              whileInView="visible"
              custom={0.9}
              viewport={{ once: true }}
            >
              Buscamos integrar la innovación y la resiliencia en el desarrollo
              constructivo de la región. Este evento reunirá a profesionales
              para explorar la vanguardia en análisis, diseño y rehabilitación
              de estructuras, con un enfoque crucial en la sismo-resistencia,
              materiales avanzados y soluciones sostenibles para la
              infraestructura sudamericana.
            </motion.p>

       
          </div>
        </div>
      </section>
    </div>
  );
}

export default HeroSection;
